import styled, { css } from 'styled-components';
import { palette } from '../../theme/colors';
import { toRem } from '../../utils/toRem';

export const SContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
  cursor: pointer;
`;

export const SDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: ${toRem(5)};
  background-color: ${palette.prussianBlue};
  border: 1px solid ${palette.queenBlue};
  border-radius: 0.625rem;
  overflow: hidden;
  z-index: 1000;
  max-height: 12.5rem;
  overflow-y: auto;
`;

export const SRegionItem = styled.div`
  padding: ${toRem(12)} ${toRem(15)};
  cursor: pointer;
  border-bottom: 1px solid ${palette.lightWhite};
  color: ${palette.grayx11gray};
  font-size: ${toRem(14)};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${palette.prussianBlue5};
  }
`;

export const STextFieldEndPlaceHolder = styled.div`
  min-height: 3.4375rem;
  position: relative;
  display: flex;
  align-items: center;
`;

export const SPropertyDisplay = styled.div<{ $isError?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: start;
  color: ${palette.grayx11gray};
  font-family: 'Roboto-Regular';
  font-size: 1rem;
  min-height: 3.4375rem;
  width: 100%;
  padding: 0.5rem 1rem;
  background-color: ${palette.fadedDarkBlue};
  border: 1px solid ${palette.siamiBlue};
  border-radius: 0.93rem;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;

  ${props =>
    props.$isError &&
    css`
      border: 1px solid ${palette.tartOrange};
    `}

  .arrow {
    position: absolute;
    right: 1rem;
    transition: transform 0.3s ease;
  }

  .arrow.open {
    transform: rotate(180deg);
  }

  label {
    z-index: 10;
    left: 1rem;
    margin-right: 0.75rem;
  }
`;
